import ReactDOM from "react-dom";
import { App } from "./app";
import { BrowserRouter, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "oidc-react";
import { config } from "config";
import { ThemeProvider } from "@hcss/theme";
import { RemarkableProvider } from "@hcss/remarkable";
import { PropsWithChildren } from "react-router/node_modules/@types/react";
import { QueryParamProvider } from "use-query-params";
import { LoadingFallback } from "components/loading-fallback";
import { parse } from "query-string";

const AppWithProviders = () => {
  return (
    <AuthProvider
      {...config.oidc}
      onBeforeSignIn={storeRedirect}
      automaticSilentRenew
    >
      <BrowserRouter>
        <QueryParamProvider ReactRouterRoute={Route}>
          <ThemeProvider productColor="#1e1e1e">
            <AuthedProviders>
              <App />
            </AuthedProviders>
          </ThemeProvider>
        </QueryParamProvider>
      </BrowserRouter>
    </AuthProvider>
  );
};

const AuthedProviders = ({ children }: PropsWithChildren<{}>) => {
  const { userData } = useAuth();
  if (!userData?.access_token) return <LoadingFallback />;
  return (
    <RemarkableProvider
      token={userData?.access_token ?? ""}
      baseUrl={config.endpoints.remarkable}
    >
      {children}
    </RemarkableProvider>
  );
};

function storeRedirect() {
  window.localStorage.setItem("preRedirectQueryParams", window.location.search);
}

ReactDOM.render(<AppWithProviders />, document.getElementById("root"));
